export const STATIC_URL = "https://login-server123.herokuapp.com/";
